// InputDateForm.tsx
import React from 'react';
import { Grid, styled, TextField, Typography } from "@mui/material";
import { Controller, Control, FieldError } from 'react-hook-form';

// Reusing styled components for consistency
const DescGrid = styled(Grid)(({ theme }) => ({
  padding: "1%",
}));

const TitleGrid = styled(Grid)(({ theme }) => ({
  paddingLeft: "10%",
}));

const FullTextField = styled(TextField)(({ theme }) => ({
  width: "80%",
}));

interface DatePickerProps {
  name: string;
  control: Control<any>;
  label: string;
  error?: FieldError | undefined;
  disabled:boolean;
}

const InputDateForm: React.FC<DatePickerProps> = ({ name, control, label, error, disabled }) => {
  return (
    <Grid container justifyContent="center">
      <DescGrid container justifyContent="center">
        <TitleGrid item xs={12}>
          <Typography variant="h6" color="black">
            {label}
          </Typography>
        </TitleGrid>
        <Grid container justifyContent="center" item xs={12}>
          <Controller
            name={name}
            control={control}
            render={({ field }) => (
              <FullTextField
                {...field}
                disabled={disabled}
                type="date"
                error={!!error}
                helperText={error ? error.message : null}
                InputLabelProps={{
                  shrink: true,
                }}
                fullWidth
                variant="outlined"
              />
            )}
          />
        </Grid>
      </DescGrid>
    </Grid>
  );
};

export default InputDateForm;
